const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const sections = document.querySelectorAll('.accordion');

sections.forEach((section) => {
	const triggers = section.querySelectorAll('.open-accordion');
	if (!triggers.length) return;

	const closeAll = (except = null) => {
		section.querySelectorAll('.open-accordion').forEach((btn) => {
			if (btn === except) return;
			const panel = btn.nextElementSibling;
			if (!panel) return;
			panel.classList.remove('show');
			btn.classList.remove('rotate');
			btn.setAttribute('aria-expanded', 'false');
		});
	};

	const openPanel = (btn, panel) => {
		panel.classList.add('show');
		btn.classList.add('rotate');
		btn.setAttribute('aria-expanded', 'true');
	};

	triggers.forEach((btn) => {
		const panel = btn.nextElementSibling;
		if (!panel) return;

		btn.addEventListener('click', () => {
			const isOpen = panel.classList.contains('show');

			if (isOpen) {
				panel.classList.remove('show');
				btn.classList.remove('rotate');
				btn.setAttribute('aria-expanded', 'false');
				return;
			}

			const currentlyOpen = section.querySelector('.content-wrapper.show');

			if (!currentlyOpen || prefersReducedMotion) {
				closeAll();
				openPanel(btn, panel);
				return;
			}

			// Wait for the close animation to finish before opening the next one
			const onClosed = (event) => {
				if (event.propertyName !== 'grid-template-rows') return;
				currentlyOpen.removeEventListener('transitionend', onClosed);
				openPanel(btn, panel);
			};
			currentlyOpen.addEventListener('transitionend', onClosed);
			closeAll();
		});
	});
});
